import { FC, useEffect } from 'react';
import { useRouter } from 'next/router';
import { useTheme } from '@mui/material';
import menuItems from './items';
import { OptionsMenuItem } from '@/common/components/OptionsMenuItem/OptionsMenuItem';
import { routeProvider } from '@/common/utils';

interface UserMenuItemsProps {
  handleCloseMenu?: () => void;
}

export const UserMenuItems: FC<UserMenuItemsProps> = ({ handleCloseMenu }) => {
  const theme = useTheme();
  const router = useRouter();

  const handlePathChange = () => {
    if (!router.isReady) {
      return;
    }
  };

  useEffect(handlePathChange, [router.isReady, router.asPath]);

  return (
    <>
      {menuItems.map((item, index) => {
        const active = router.query.tab?.includes(item.query);

        const handleOnClick = () => {
          handleCloseMenu();
        };

        return (
          <OptionsMenuItem
            key={index}
            link={{
              pathname: routeProvider.userAcount,
              query: { tab: item.query }
            }}
            active={active}
            handleOnClick={handleOnClick}
            listItemStyles={{ p: theme.spacing(0.1, 2.5) }}
            {...item}
          />
        );
      })}
    </>
  );
};
